import axios from 'axios';
import {
  BuMonitoring,
  ListService,
  PacketPowerBaieMetric,
  PacketPowerCable,
  PacketPowerGraph,
} from '../Types/service';
import {GraphServiceType} from '../Types/graphPeriods';
import {TelephonyUsageResponse} from '../Types/type';


const getServicesByClient = async (serviceType?: string) => {
    const response = await axios.get('/api/services', {
        params: serviceType ? {type: serviceType} : {},
    });

    return response.data;
};

const getServicesInfo = async (serviceId:string) => {
    const response = await axios.get(`/api/services/${serviceId}`, {
        params: {},
    });

    return (response.data.length > 0 ) ? response.data[0] : null ;
};

const getCompteFTP = async (buID:string) => {
    const response = await axios.get('/api/services/hebergement/compteFTP' , {
        params: {},
    });

    return response.data;
};

const getCompteDB = async (buID:string) => {
    const response = await axios.get('/api/services/hebergement/compteDB' , {
        params: {},
    });

    return response.data;
};

const getDomaineInfo = async (buId:string, domain:string) => {
    const response = await axios.get(`/api/services/hebergement/${buId}/domains/${domain}` , {
        params: {},
    });

    return response.data;
};

const getConsommationLTE = async (cisId:string) => {
    const response = await axios.get('/api/services/acces/consommationLTE/'+cisId , {
        params: {},
    });

    return response.data[cisId] ;
}

const getContactInformations = async () => {
    const response = await axios.get('/api/contacts/details' , {
        params: {},
    });

    return response.data;
}

const getFilteredServices = (
    services: ListService[] | undefined,
    type: string
) => {

    return services?.filter((service: ListService) => {
        return service.type.includes(type);
    })
};

const getTelephonieUsage = async (datas: Object): Promise<TelephonyUsageResponse> => {
  const response = await axios.get('/api/services/telephonie/usage', {
    params: datas,
  });

  return response.data;
};

const getTelephonieContext = async () => {
    const response = await axios.get('/api/services/telephonie/context');
    return response.data;
}


const getTelephonieDetails = async (datas: Object) => {
    const response = await axios.post('/api/services/telephonie/details', datas);
    return response.data;
}


const getParc4G = async (dataService:ListService) => {
    const response = await axios.post(`/api/services/telephonie/parc4G` , {
        'ligneType':dataService.bravoLineType ,
        'ligneId':dataService.serviceId
    });
    return response.data;
}

const setCommentForMSISDN = async (serviceId:string, contrat_id: string, comment: string) => {
    const response = await axios.post(`/api/services/telephonie/${serviceId}/comment`, {
        comment: comment,
        contrat_id: contrat_id
    });
    return response.data;
}

const getCompteurForMSISDN = async (serviceId:string , contratId:string) => {
    const response = await axios.get(`/api/services/telephonie/${serviceId}/compteur/${contratId}`);
    return response.data;
}

const getCommentsForMSISDNByIccid = async (iccid:string) => {
    const response = await axios.get(`/api/services/telephonie/comment/${iccid}`);
    return response.data.commentaire;
}

const setEtatForMSISDN = async (serviceId:string, contrat_id: string, etat: string) => {
    const response = await axios.post(`/api/services/telephonie/${serviceId}/etat`, {
        etat: etat,
        contrat_id: contrat_id
    });
    return response;
}

const setSvaForMSISDN = async (serviceId:string, contrat_id: string, sva: string) => {
    const response = await axios.post(`/api/services/telephonie/${serviceId}/sva`, {
        sva: sva,
        contrat_id: contrat_id
    });
    return response;
}

const getMonitoring = async (): Promise<BuMonitoring[]> => {
    const response = await axios.get('/api/services/monitoring');
    return response.data;
};

const getGraph = async (
    buId: string,
    serviceType: GraphServiceType,
    periodHours: number,
): Promise<{base64: string | null}> => {
    const response = await axios.get('/api/services/monitoring/graph', {
        params: {bu_id: buId, service_type: serviceType, period_hours: periodHours},
    });
    return response.data;
};

const getPacketPowerCables = async (serviceId: number): Promise<PacketPowerCable[]> => {
    const response = await axios.get(`/api/services/centreon/packet-power/cables/${serviceId}`);
    return response.data;
};

const getPacketPowerBaies = async (
    serviceId: number,
    cable: string,
): Promise<PacketPowerBaieMetric[]> => {
    const response = await axios.get('/api/services/centreon/packet-power/baies', {
        params: {linkId: serviceId, cable},
    });
    return response.data;
};

const getPacketPowerGraph = async (
    serviceId: number,
    metricName: string,
    cable: string,
    periodHours: number,
): Promise<{graphs: PacketPowerGraph[]}> => {
    const response = await axios.get('/api/services/centreon/packet-power/graph', {
        params: {linkId: serviceId, metric_name: metricName, cable, period_hours: periodHours},
    });
    return response.data;
};

export {getServicesByClient, getServicesInfo, getFilteredServices, getCompteFTP, getDomaineInfo, getCompteDB, getConsommationLTE, getContactInformations, getTelephonieUsage, getTelephonieContext, getTelephonieDetails, getParc4G, setCommentForMSISDN, getCommentsForMSISDNByIccid, getCompteurForMSISDN, setEtatForMSISDN, setSvaForMSISDN, getMonitoring, getGraph, getPacketPowerCables, getPacketPowerBaies, getPacketPowerGraph};
